import axios from "axios";
import router from "../routes.js";
import bus from "@/utils/bus";
// console.log(location.href.toString().includes("globalcareinfo"));
// let baseURL="https://www.globalcareinfo.com/api"
// if (process.env.NODE_ENV === 'development') {
//   // 开发环境下的操作，例如使用本地模拟数据等
//   baseURL="http://127.0.0.1:7007",
// } else if (process.env.NODE_ENV === 'production') {
//   baseURL="https://www.globalcareinfo.com/api"
//   // 生产环境下的操作，例如优化代码、使用真实服务器地址等
// } else if (process.env.NODE_ENV === 'test') {
//   // 测试环境下的操作，例如连接测试服务器等
//   baseURL="http://test01.oointer.com/api"
// }
const request = axios.create({
  // baseURL: location.href.toString().includes('globalcareinfo') ? 'https://www.globalcareinfo.com/api' : 'https://gci.oointer.com',
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // bus.$emit('loading', true)
    const token = localStorage.getItem("token");
    if (token !== null && token !== "") {
      config.headers["authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (res) => {
    // bus.$emit('loading', false)
    // bus.$emit('noloading', false)
    // console.log("res0000", res);
    //有url直接返回res.data
    if (res.data.url) {
      return res.data;
    }
    if (res.data.status != 0) {
      if (res.data.status == 1001) {
        if (localStorage.getItem("isMobile") == "null") {
          bus.$emit("login", true);
        } else {
          router.push({
            name: "mlogin",
            query: {
              type: 0,
              redirect: window.location.href,
            },
          });
        }
        // bus.$emit('login', true)
      }
      return bus.$emit("message", {
        type: 1,
        msg: res.data.msg,
      });
    }

    return res.data;
  },
  (error) => {
    // bus.$emit('loading', false)
    // bus.$emit('noloading', false)
    console.error(error);
    return Promise.reject(error);
  }
);
export default request;
